import _ from 'lodash';

export const Config = _(process.env)
    .keys()
    .filter((key) => key.startsWith('REACT_APP_'))
    .map((key) => [key.replace(/^REACT_APP_/, ''), process.env[key]])
    .fromPairs()
    .value();
